import { lazy } from 'react';
import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor für das Bootstrap — Slot-Renderer ist React.lazy,
 * sodass der Kommentar-Thread erst lädt, wenn der Tab-Slot rendert.
 */
const manifest: SkillManifest = {
  key: 'comments-mentions',
  name: 'Kommentare & Erwähnungen',
  description: 'Threaded Kommentare auf Projekt-Ebene mit @-Erwähnungen und Notifications.',
  category: 'collaboration',
  version: '0.1.0',
  requiredPermissions: [Permission.PROJECT_READ],
  enabledByDefault: true,
};

const CommentsThread = lazy(() =>
  import('./CommentsThread').then((m) => ({ default: m.CommentsThread })),
);

export const commentsMentionsSkill: FrontendSkill = {
  manifest,
  slots: {
    'project-detail.tabs': [
      {
        key: 'comments-thread',
        order: 20,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId + readOnly
        render: CommentsThread,
      },
    ],
  },
};
